import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import { DriverForm } from './_DriverForm'
import { useDriverManagement } from '@api/useDriverManagement'

export const DriverAdmin = ({
  selectedDriver,
  payConfigNames,
  metadata,
  creatingDriver,
  setSelectedDriver,
  setCreatingDriver,
  editing,
  setEditing,
  reloadData,
  setLoading,
}) => {
  const [driver, setDriver] = useState()
  const [viewingPWModal, setViewingPWModal] = useState(false)
  const { useDriverByIdQuery } = useDriverManagement()
  const { data: driverData, isPending, isFetching } = useDriverByIdQuery(selectedDriver?.id)
  useEffect(() => {
    if (!creatingDriver && driverData && !isPending && !isFetching) {
      setCreatingDriver(false)
      setEditing(false)
      setDriver({ ...driverData, depot: driverData?.depot_name })
    } else setDriver(undefined)
  }, [driverData, isPending, isFetching])

  if (!driver && !creatingDriver) return null

  const driverInfoClasses = creatingDriver ? 'mb-3' : 'mb-3 pr-1'

  return (
    <div className={`${driver ? 'driver' : ''} dashboard-container p-4`}>
      <Row style={{ flex: 1 }}>
        <Col span={24} className=''>
          <div className='dashboard-container fill-height'>
            <Row>
              <Col span={24} className={driverInfoClasses}>
                <DriverForm
                  selectedDriver={selectedDriver}
                  driver={driver}
                  setDriver={setDriver}
                  reloadData={reloadData}
                  creatingDriver={creatingDriver}
                  payConfigNames={payConfigNames}
                  metadata={metadata}
                  setSelectedDriver={setSelectedDriver}
                  setCreatingDriver={setCreatingDriver}
                  editing={editing}
                  setEditing={setEditing}
                  setLoading={setLoading}
                  viewingPWModal={viewingPWModal}
                  setViewingPWModal={setViewingPWModal}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}
